import React from 'react';
import { Routes, Route, BrowserRouter as Router, Link } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import CheckAccessibility from './components/CheckAccessibility';
import FAQ from './components/Faq';
import './App.css'; // Import your custom CSS if any
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import logo from './assets/logo.png'; // Import the logo image

const App = () => {
  return (
    <Router>
      <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: '#e3f2fd', justifyContent: 'left' }}>
        <div className="container-fluid">
        <Link className="navbar-brand d-flex align-items-center" to="/">
            <img src={logo} alt="Logo" height="100" />
            <h1 style={{ 'marginLeft': '20px' }}>AI Web Accessibility Checker</h1>
          </Link>
          <div className="navbar" id="navbarNav">
            <ul className="nav nav-pills navbar-right">
              <li className="nav-item">
                <Link className="nav-link" to="/home">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/faq">FAQ</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className="container mt-4">
        <Routes>
          <Route path="/" element={<CheckAccessibility  />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/home" element={< Home/>} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;